<div class="container">
    <div class="page-header no-print">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 3v18h18"></path>
                <path d="M7 14l4-4 4 4 5-6"></path>
            </svg>
        </div>
        <div>
            <h1>Demonstrativo de Vendas</h1>
            <p>Selecione um cliente</p>
        </div>
    </div>

    <section class="demonstrativo-shell" (click)="fecharMenusDemonstrativo()">
        <section class="action-bar no-print">
            <div *ngIf="demonstrativoLoading()" class="loading-overlay">
                <app-loading-indicator></app-loading-indicator>
            </div>

            <div class="action-header">
                <div class="action-title-row">
                    <div class="cliente-endereco-group">
                    <div class="cliente-selector">
                        <div class="cliente-selector-top">
                            <label class="cliente-selector-field">{{ demonstrativoBuscaLabel() }}</label>
                            <label class="busca-tipo-option">
                                <input type="radio" name="demonstrativoTipoBusca"
                                       [checked]="demonstrativoTipoBusca === 'CLIENTE'"
                                       (change)="alterarTipoBuscaDemonstrativo('CLIENTE')">
                                Cliente
                            </label>
                            <label class="busca-tipo-option">
                                <input type="radio" name="demonstrativoTipoBusca"
                                       [checked]="demonstrativoTipoBusca === 'VENDEDOR'"
                                       (change)="alterarTipoBuscaDemonstrativo('VENDEDOR')">
                                Vendedor
                            </label>
                            <label class="busca-tipo-option">
                                <input type="radio" name="demonstrativoTipoBusca"
                                       [checked]="demonstrativoTipoBusca === 'PREFIXO'"
                                       (change)="alterarTipoBuscaDemonstrativo('PREFIXO')">
                                Prefixo
                            </label>
                        </div>
                        <div class="cliente-input-wrapper" (click)="$event.stopPropagation()">
                            <input
                                    id="buscarCliente"
                                    class="input-cliente-selector"
                                    name="demonstrativoCliente"
                                    [placeholder]="demonstrativoBuscaPlaceholder()"
                                    autocomplete="off"
                                    autocorrect="off"
                                    autocapitalize="off"
                                    spellcheck="false"
                                    [(ngModel)]="demonstrativoFiltroCliente"
                                    (input)="agendarBuscaClientesDemonstrativo()"
                                    (keyup.enter)="buscarClientesDemonstrativo()"
                                    (focus)="demonstrativoFiltroCliente.trim().length >= 2 && (demonstrativoDropdownClientesAberto = true)"
                            >
                            <ul id="listaClientes" class="listaSug" *ngIf="demonstrativoDropdownClientesAberto">
                                <li *ngFor="let cliente of demonstrativoClientes()"
                                    (click)="selecionarCliente(cliente)">
                                    <strong>
                                        {{
                                        demonstrativoTipoBusca === 'PREFIXO'
                                        ? cliente.prefixo
                                        : cliente.nomeparc
                                        }}
                                    </strong>
                                    <span>
                                        {{
                                            demonstrativoTipoBusca === 'VENDEDOR'
                                                ? documentoClienteDemonstrativo(cliente)
                                                : demonstrativoTipoBusca === 'PREFIXO'
                                                    ? cliente.nomeparc
                                                    : 'CNPJ: ' + documentoClienteDemonstrativo(cliente)
                                        }}
                                    </span>
                                </li>
                                <li class="listaSug-empty"
                                    *ngIf="!demonstrativoClientes().length && demonstrativoStatus()">
                                    <span>{{ demonstrativoStatus() }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <button
                            type="button"
                            class="demonstrativo-endereco-trigger"
                            [class.oculto]="!mostrarFiltroEnderecoDemonstrativo()"
                            [disabled]="!mostrarFiltroEnderecoDemonstrativo()"
                            [attr.aria-hidden]="!mostrarFiltroEnderecoDemonstrativo()"
                            [tabIndex]="mostrarFiltroEnderecoDemonstrativo() ? 0 : -1"
                            title="Filtrar vendas por endereco"
                            aria-label="Filtrar vendas por endereco"
                            (click)="abrirFiltroEnderecoDemonstrativo($event)">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 21s6-5.4 6-12a6 6 0 1 0-12 0c0 6.6 6 12 6 12z"></path>
                            <circle cx="12" cy="9" r="2.2"></circle>
                        </svg>
                        <span>{{ demonstrativoCodparcsComVendas.length }}</span>
                    </button>
                    </div>

                    <div class="date-filter-group">
                        <div class="date-field">
                            <label>Data Inicial:</label>
                            <input class="input-date" type="date" name="demonstrativoDataInicial"
                                   [(ngModel)]="demonstrativoDataInicial">
                        </div>
                        <div class="date-field">
                            <label>Data Final:</label>
                            <input class="input-date" type="date" name="demonstrativoDataFinal"
                                   [(ngModel)]="demonstrativoDataFinal">
                        </div>
                        <div class="date-field demonstrativo-botoes-busca"
                             style="display: flex; flex-direction: row; align-items: flex-end; gap: 8px; align-self: flex-end;">
                            <button
                                    type="button"
                                    class="btn-selecionar-cliente"
                                    (click)="buscarDadosDemonstrativo()"
                                    [disabled]="!demonstrativoCodparc || demonstrativoLoading()">
                                Buscar
                            </button>
                            <button
                                    type="button"
                                    class="btn-selecionar-cliente btn-limpar-demonstrativo"
                                    (click)="limparBuscaDemonstrativo()"
                                    [disabled]="demonstrativoLoading()">
                                Limpar
                            </button>
                        </div>
                    </div>

                    <div class="actions-bottom dIni" *ngIf="demonstrativoTemDados()">
                        <div class="whatsapp-box">
                            <input
                                    type="text"
                                    class="input-whatsapp"
                                    placeholder="Digite o WhatsApp"
                                    maxlength="13"
                                    inputmode="numeric"
                                    autocomplete="tel"
                                    [ngModel]="demonstrativoWhatsappNumero"
                                    (ngModelChange)="formatarWhatsappDemonstrativo($event)"
                            >
                            <button
                                    type="button"
                                    class="btn-whatsapp"
                                    [class.btn-whatsapp-inativo]="!whatsappDemonstrativoValido()"
                                    [attr.aria-disabled]="!whatsappDemonstrativoValido()"
                                    (click)="enviarWhatsappDemonstrativo()">
                                WhatsApp
                            </button>
                        </div>
                        <button type="button" class="btn-pdf" (click)="salvarPdfDemonstrativo()">
                            Salvar PDF
                        </button>
                        <button type="button" class="btn-print" (click)="imprimirDemonstrativo()">
                            Imprimir
                        </button>
                    </div>

                    <div class="divisor-vertical dIni" *ngIf="demonstrativoTemDados()"></div>

                    <div class="menu-wrapper dIni" *ngIf="demonstrativoTemDados()" (click)="$event.stopPropagation()">
                        <button type="button" class="menu-btn" (click)="toggleMenuDemonstrativo($event)"
                                title="Menu de acoes">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        <div class="menu-dropdown" [class.ativo]="demonstrativoAbrirMenu">
                            <div class="menu-item" (click)="abrirCotacoes()">
                                Alterar cotacao para selecionados.
                            </div>
                            <div class="menu-item" *ngIf="demonstrativoTipoBusca !== 'PREFIXO'"
                                 (click)="abrirAlterarPrefixo()">
                                Alterar prefixo para selecionados.
                            </div>
                            <div class="menu-item" (click)="abrirAlterarClienteVendas()">
                                Alterar cliente para vendas selecionadas.
                            </div>
                            <div class="menu-item" (click)="abrirModalTipoNegociacao()">
                                Alterar Forma de pagamento para selecionados.
                            </div>
                            <div class="menu-item" (click)="abrirAjusteNotas()">
                                Desconto / Acrescimo para selecionados.
                            </div>
                            <div class="menu-item" (click)="abrirFinalizarVendas()">
                                Finalizar vendas para selecionados.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="toolbar-line">
                    <div class="filters-container">

                        <div class="cliente-selector dIni" *ngIf="demonstrativoTemDados()">
                            <div class="grupo-wrapper">
                <span class="grupo-titulo">
                    Valor {{ demonstrativoTipoMoeda === 'REAL' ? 'Pix R' : 'Dolar U' }}$
                </span>
                                <div class="grupo-body">
                                    <input
                                            type="text"
                                            class="input-valorpix-selector"
                                            [placeholder]="demonstrativoValorPixQrCode"
                                            [(ngModel)]="demonstrativoValorPixQrCode">
                                    <button
                                            type="button"
                                            class="btn-selecionar-cliente"
                                            (click)="alterarValorPix()">
                                        Alterar Valor do Qr-Code Pix
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div class="divisor-vertical dIni"
                             *ngIf="demonstrativoTemDados() && demonstrativoTipoBusca !== 'PREFIXO'"></div>

                        <div class="prefixo-filter dIni"
                             *ngIf="demonstrativoTemDados() && demonstrativoTipoBusca !== 'PREFIXO'">
                            <label>Prefixo:</label>
                            <div class="prefixo-dropdown-wrapper" (click)="$event.stopPropagation()">
                                <div class="prefixo-dropdown-btn"
                                     (click)="toggleDropdownDemonstrativo('prefixos', $event)">
                                    <span>Filtrar Prefixos</span>
                                    <span class="seta">v</span>
                                </div>
                                <div class="prefixo-dropdown-menu" *ngIf="demonstrativoAbrirPrefixos">
                                    <div class="prefixo-item" [class.active]="!demonstrativoPrefixosSelecionados.length"
                                         (click)="filtrarPrefixo('TODOS')">
                                        TODOS
                                    </div>
                                    <div
                                            class="prefixo-item"
                                            *ngFor="let prefixo of demonstrativoPrefixosDisponiveis"
                                            [class.active]="demonstrativoPrefixosSelecionados.includes(prefixo)"
                                            (click)="filtrarPrefixo(prefixo)"
                                    >
                                        {{ prefixo }}
                                    </div>
                                    <div class="prefixo-filtrar-btn" (click)="demonstrativoAbrirPrefixos = false">
                                        FECHAR
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="divisor-vertical dIni" *ngIf="demonstrativoTemDados()"></div>

                        <div class="prefixo-filter dIni" *ngIf="demonstrativoTemDados()">
                            <label>Empresa:</label>
                            <div class="prefixo-dropdown-wrapper" (click)="$event.stopPropagation()">
                                <div class="prefixo-dropdown-btn"
                                     (click)="toggleDropdownDemonstrativo('empresas', $event)">
                                    <span>Filtrar Empresa</span>
                                    <span class="seta">v</span>
                                </div>
                                <div class="prefixo-dropdown-menu" *ngIf="demonstrativoAbrirEmpresas">
                                    <div class="prefixo-item" [class.active]="!demonstrativoEmpresasSelecionadas.length"
                                         (click)="filtrarEmpresa('TODOS')">
                                        TODAS
                                    </div>
                                    <div
                                            class="prefixo-item"
                                            *ngFor="let emp of demonstrativoEmpresasDisponiveis"
                                            [class.active]="demonstrativoEmpresasSelecionadas.includes(emp)"
                                            (click)="filtrarEmpresa(emp)"
                                    >
                                        {{ emp }}
                                    </div>
                                    <div class="prefixo-filtrar-btn" (click)="demonstrativoAbrirEmpresas = false">
                                        FECHAR
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="divisor-vertical dIni" *ngIf="demonstrativoTemDados()"></div>

                        <div class="prefixo-filter dIni" *ngIf="demonstrativoTemDados()">
                            <label>Codigo:</label>

                            <div class="prefixo-dropdown-wrapper" (click)="$event.stopPropagation()">
                                <div class="prefixo-dropdown-btn"
                                     (click)="toggleDropdownDemonstrativo('codigos', $event)">
                                    <span>Filtrar Vendas</span>
                                    <span class="seta">v</span>
                                </div>

                                <div class="prefixo-dropdown-menu" *ngIf="demonstrativoAbrirCodigos">
                                    <div
                                            class="prefixo-item"
                                            [class.active]="!demonstrativoCodigosSelecionados.length"
                                            (click)="filtrarCodigo('TODOS')">
                                        TODOS
                                    </div>

                                    <div
                                            class="prefixo-item"
                                            *ngFor="let codigo of demonstrativoCodigosDisponiveis"
                                            [class.active]="demonstrativoCodigosSelecionados.includes(codigo)"
                                            (click)="filtrarCodigo(codigo)">
                                        {{ codigo }}
                                    </div>

                                    <div class="prefixo-filtrar-btn" (click)="demonstrativoAbrirCodigos = false">
                                        FECHAR
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="zoom-controls dIni" *ngIf="demonstrativoTemDados()">
                        <button type="button" class="zoom-btn" (click)="zoomDemonstrativo('+')" title="Aumentar zoom">
                            <span class="zoom-icon">+</span>
                        </button>
                        <button type="button" class="zoom-btn" (click)="zoomDemonstrativo('-')" title="Diminuir zoom">
                            <span class="zoom-icon">-</span>
                        </button>
                        <button type="button" class="zoom-btn zoom-toggle-btn" (click)="alternarZoomDemonstrativo()"
                                [title]="demonstrativoZoomAtual >= 1.6 ? 'Voltar ao zoom padrao' : 'Aplicar zoom maximo'">
                            <lucide-angular [img]="demonstrativoZoomAtual >= 1.6 ? ZoomOut : ZoomIn"
                                            size="18"></lucide-angular>
                        </button>
                    </div>
                </div>
                <div style="height: 5px;"></div>
                <div class="toolbar-line">
                    <div class="filters-container">
                        <div class="moeda-filter-wrapper dIni" *ngIf="demonstrativoTemDados()">
                            <label class="moeda-label">Moeda:</label>
                            <div class="moeda-filter-buttons">
                                <button
                                        type="button"
                                        class="filter-chip"
                                        [class.active]="demonstrativoTipoMoeda === 'DOLAR'"
                                        (click)="alternarMoeda('DOLAR')"
                                >
                                    U$ Dolar
                                </button>
                                <button
                                        type="button"
                                        class="filter-chip"
                                        [class.active]="demonstrativoTipoMoeda === 'REAL'"
                                        (click)="alternarMoeda('REAL')"
                                >
                                    R$ Real
                                </button>
                            </div>
                        </div>

                        <div class="divisor-vertical dIni" *ngIf="demonstrativoTemDados()"></div>

                        <div class="date-filter-group dIni" *ngIf="demonstrativoTemDados()">
                            <div class="date-field status-field">
                                <label>Status:</label>
                                <button
                                        type="button"
                                        class="filter-chip"
                                        [class.active]="!demonstrativoStatusSelecionados.length"
                                        (click)="filtrarStatus('TODOS')"
                                >
                                    TODOS
                                </button>
                            </div>
                            <button
                                    type="button"
                                    class="filter-chip"
                                    *ngFor="let status of demonstrativoStatusDisponiveis"
                                    [class.active]="demonstrativoStatusSelecionados.includes(status)"
                                    (click)="filtrarStatus(status)"
                            >
                                {{ status }}
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <section class="demonstrativo-empty-card no-print" *ngIf="demonstrativoBuscaSemDados">
            <div class="demonstrativo-empty-icon">!</div>
            <div>
                <h2>Nenhum dado encontrado</h2>
                <p>{{ mensagemSemDadosDemonstrativo() }}</p>
            </div>
        </section>

        <section class="page-a4" *ngIf="!demonstrativoBuscaSemDados && demonstrativoDados() as dados"
                 [ngStyle]="pageA4Style()">
            <div class="top-report-header">
                <div class="logo-area">
                    <div class="logo-main">
                        <img src="/assets/legacy-html5/GPL_DemonstrativoDeVendas/assets/logo_global.png" height="50"
                             width="303" alt="GlobalParts">
                    </div>
                </div>

                <div class="header-right">
                    <div class="linha-info"><strong>Empresa:</strong> <span>0000001</span></div>
                    <div class="linha-info"><strong>Usuario:</strong> <span>{{ usuarioLogado() }}</span>
                    </div>
                    <div class="linha-info"><strong>Data:</strong> <span>{{ demonstrativoDataAtual() }}</span></div>
                    <div class="linha-info"><strong>Hora:</strong> <span>{{ demonstrativoHoraAtual() }}</span></div>
                </div>
            </div>

            <div class="report-title">
                DEMONSTRATIVO DE VENDAS
                <span *ngIf="demonstrativoTipoMoeda === 'DOLAR'">(EM DOLAR)</span>
            </div>

            <div class="cliente-header">
                <div class="cliente-box-info" *ngIf="demonstrativoTipoBusca !== 'PREFIXO'">
                <span class="cliente-label">
                    {{ demonstrativoTipoBusca === 'VENDEDOR' ? 'VENDEDOR:' : 'CLIENTE:' }}
                </span>

                    <span class="cliente-value">
                    {{
                        demonstrativoTipoBusca === 'VENDEDOR'
                            ? demonstrativoFiltroCliente
                            : (dados.parceiro?.nomeParc || demonstrativoFiltroCliente)
                    }}
                </span>
                </div>

                <div class="cliente-box-info" *ngIf="demonstrativoTipoBusca === 'PREFIXO'">
                    <span class="cliente-label">PREFIXO:</span>
                    <span class="cliente-value">{{ demonstrativoPrefixoBuscaSelecionado || '-' }}</span>
                </div>

                <div
                        class="cliente-box-info cnpj-box"
                        *ngIf="demonstrativoTipoBusca === 'CLIENTE'">

                    <span class="cliente-label">{{ demonstrativoDocTipo() }}</span>
                    <span class="cliente-value">{{ demonstrativoDocumento() }}</span>
                </div>

            </div>

            <table class="tb-itens table-mini" [class.impressao-sem-cotacao]="!demonstrativoImprimirCotacao">
                <thead>
                <tr>
                    <th class="no-print">
                        <input type="checkbox" [checked]="demonstrativoSelecionarTodos"
                               (change)="marcarTodosDemonstrativo()">
                    </th>
                    <th class="sortable" (click)="ordenarDemonstrativo('ord')">Ord
                        <span>{{ ordemOrdAsc ? '^' : 'v' }}</span></th>
                    <th class="sortable" (click)="ordenarDemonstrativo('emp')">Emp.
                        <span>{{ ordemEmpAsc ? '^' : 'v' }}</span></th>
                    <th *ngIf="demonstrativoTipoBusca === 'VENDEDOR'">
                        Cliente
                    </th>
                    <th *ngIf="demonstrativoTipoBusca === 'CLIENTE'">
                        Vendedor
                    </th>
                    <th *ngIf="demonstrativoTipoBusca === 'PREFIXO'">
                        Cliente
                    </th>
                    <th *ngIf="demonstrativoTipoBusca === 'PREFIXO'">
                        Vendedor
                    </th>
                    <th>Codigo</th>
                    <th *ngIf="demonstrativoTipoBusca !== 'PREFIXO'"
                        class="sortable" (click)="ordenarDemonstrativo('prefixo')">Prefixo <span>{{ ordemPrefixoAsc ? '^' : 'v' }}</span>
                    </th>
                    <th class="sortable" (click)="ordenarDemonstrativo('emissao')">Emissao <span>{{ ordemEmissaoAsc ? '^' : 'v' }}</span>
                    </th>
                    <th class="sortable" (click)="ordenarDemonstrativo('status')">Status <span>{{ ordemStatusAsc ? '^' : 'v' }}</span>
                    </th>
                    <th class="col-cotacao-print">Dolar</th>
                    <th>Adiant. {{ demonstrativoMoeda() }}</th>
                    <th>Total {{ demonstrativoMoeda() }}</th>
                    <th>Dev. {{ demonstrativoMoeda() }}</th>
                    <th>Vlr Final {{ demonstrativoMoeda() }}</th>
                </tr>
                </thead>

                <tbody>
                <tr *ngFor="let item of demonstrativoItens()" [class.linha-selecionada]="item['selecionado']"
                    [class.no-print]="item['noPrint']">
                    <td class="no-print">
                        <input type="checkbox" [(ngModel)]="item['selecionado']"
                               (ngModelChange)="validarSelecionadosDemonstrativo()">
                    </td>
                    <td>{{ getCell(item, 'ord') }}</td>
                    <td>{{ getCell(item, 'emp') }}</td>
                    <td *ngIf="demonstrativoTipoBusca === 'VENDEDOR'">
                        {{ getCell(item, 'cliente') || '-' }}
                    </td>
                    <td *ngIf="demonstrativoTipoBusca === 'CLIENTE'">
                        {{ getCell(item, 'vendedor') }}
                    </td>
                    <td *ngIf="demonstrativoTipoBusca === 'PREFIXO'">
                        {{ getCell(item, 'cliente') || '-' }}
                    </td>
                    <td *ngIf="demonstrativoTipoBusca === 'PREFIXO'">
                        {{ getCell(item, 'vendedor') || '-' }}
                    </td>
                    <td class="codigo-impressao">
                        <button type="button" class="codigo-link no-print-inline"
                                (click)="abrirVendaImpressao(item, $event)">{{ getCell(item, 'codigo') }}
                        </button>
                        <span class="print-only-inline">{{ getCell(item, 'codigo') }}</span>
                    </td>
                    <td *ngIf="demonstrativoTipoBusca !== 'PREFIXO'">{{ getCell(item, 'prefixo') }}</td>
                    <td>{{ getCell(item, 'emissao') }}</td>
                    <td>{{ getCell(item, 'status') }}</td>
                    <td class="col-cotacao-print">{{ getCell(item, 'dolar') }}</td>
                    <td>{{ getCell(item, 'adiant') }}</td>
                    <td>{{ getCell(item, 'faturado') }}</td>
                    <td>{{ getCell(item, 'devolucao') || getCell(item, 'dev') }}</td>
                    <td class="text-right">{{ getCell(item, 'valorFinal') || getCell(item, 'faturado') }}</td>
                </tr>
                </tbody>
            </table>

            <div class="totalizacao">
                <div class="credito-info">
                    Creditos de Adiantamento Avulso:
                    <span>{{ demonstrativoMoeda() }} 0,00</span>
                </div>

                <div class="summary-values">
                    <table>
                        <tr>
                            <td class="label">Totais:</td>
                            <td class="value">{{ demonstrativoMoeda() }} {{ demonstrativoTotalFaturado() }}</td>
                        </tr>
                        <tr>
                            <td class="label">Adiantamento:</td>
                            <td class="value">{{ demonstrativoMoeda() }} 0,00</td>
                        </tr>
                        <tr class="total-final-row">
                            <td colspan="2">
                                <span class="total-final-label">Total Final:</span>
                                <span class="total-final-value">{{ demonstrativoMoeda() }} {{ demonstrativoTotalFaturado() }}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div class="payment-section" *ngIf="demonstrativoContas.length">
                <div class="payment-title">Dados para pagamento</div>
                <div class="pix-container" [class.pix-container-three]="demonstrativoContas.length === 3">
                    <article class="pix-box" *ngFor="let conta of demonstrativoContas">
                        <div class="pix-qrcode">
                            <img [src]="getCell(conta, 'imagem')" alt="QR Code PIX">
                        </div>
                        <div class="pix-dados">
                            <strong>
                                <img *ngIf="iconeBanco(conta) as icone" class="pix-bank-icon"
                                     [src]="icone" alt="" aria-hidden="true">
                                DEPOSITAR: {{ getCell(conta, 'deposito') }}
                            </strong>
                            <p>{{ getCell(conta, 'conta') }}</p>
                            <p>Favorecido: {{ getCell(conta, 'favorecido') }}</p>
                            <p>CPF/CNPJ: {{ getCell(conta, 'cnpj') }}</p>
                        </div>
                        <p class="pix-chave">Chave PIX: <strong>{{ getCell(conta, 'pix') }}</strong></p>
                    </article>
                </div>
            </div>

            <div class="footer">
                <div class="footer-bottom">
                    <div class="footer-codes">
                        0000001<br>
                        {{ dados.usuario?.NOMEUSU || '-' }}
                    </div>
                    <div class="footer-center">
                        AV. DOS INDIOS No 352, QD.124, LT. 38 - SANTA GENOVEVA - CEP 74.672-450 - GOIANIA - GO
                        <br>
                        Fone(s): + (62)3207-1414 + (62)3207-1413 - www.globalp.com.br
                    </div>
                    <div class="footer-page">
                        Pag: 1 / 1
                        <br>
                        {{ demonstrativoDataAtual() }} {{ demonstrativoHoraAtual() }}
                    </div>
                </div>
            </div>
        </section>
        <div style="min-height: 50px"></div>

        <div class="cotacao-overlay endereco-filtro-overlay" *ngIf="demonstrativoModalFiltroEndereco">
            <div class="cotacao-modal endereco-filtro-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Filtrar por endereco
                    <button type="button" class="cotacao-close" (click)="fecharFiltroEnderecoDemonstrativo()">x</button>
                </div>

                <div class="cotacao-body endereco-filtro-body">
                    <button
                            type="button"
                            class="endereco-filtro-opcao"
                            [class.selecionado]="!demonstrativoEnderecosFiltroPendentes.length"
                            (click)="selecionarEnderecoFiltroDemonstrativo('TODOS')">
                        <span class="endereco-filtro-radio"></span>
                        <span>
                            <strong>TODOS</strong>
                            <small>Exibir vendas de todos os enderecos</small>
                        </span>
                    </button>

                    <div class="endereco-filtro-carregando" *ngIf="demonstrativoEnderecosFiltroCarregando"><app-loading-indicator size="inline"></app-loading-indicator>
                        Carregando enderecos...
                    </div>

                    <button
                            type="button"
                            class="endereco-filtro-opcao"
                            *ngFor="let cliente of demonstrativoEnderecosFiltro"
                            [class.selecionado]="demonstrativoEnderecosFiltroPendentes.includes('' + cliente.codparc)"
                            (click)="selecionarEnderecoFiltroDemonstrativo(cliente.codparc)">
                        <span class="endereco-filtro-radio"></span>
                        <span>
                            <strong>Parceiro {{ cliente.codparc }}</strong>
                            <small>{{ enderecoFiltroDemonstrativoTexto(cliente) }}</small>
                        </span>
                    </button>
                </div>

                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharFiltroEnderecoDemonstrativo()">
                        Cancelar
                    </button>
                    <button type="button" class="cotacao-btn" (click)="aplicarFiltroEnderecoDemonstrativo()">
                        Filtrar
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalImpressao">
            <div class="cotacao-modal imprimir-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Confirmar impressao
                    <button type="button" class="cotacao-close" (click)="fecharModalImpressao()">x</button>
                </div>

                <div class="imprimir-opcoes">
                    <label class="imprimir-check">
                        <input type="checkbox" [(ngModel)]="demonstrativoImprimirCotacao">
                        Imprimir cotacao do dolar
                    </label>

                    <label class="imprimir-radio">
                        <input type="radio" name="tipoImpressaoDemonstrativo" value="DEMONSTRATIVO"
                               [(ngModel)]="demonstrativoTipoImpressao">
                        Imprimir somente demonstrativo
                    </label>
                    <label class="imprimir-radio">
                        <input type="radio" name="tipoImpressaoDemonstrativo" value="AMBOS"
                               [(ngModel)]="demonstrativoTipoImpressao">
                        Imprimir demonstrativo e orcamento
                    </label>
                    <label class="imprimir-radio">
                        <input type="radio" name="tipoImpressaoDemonstrativo" value="ORCAMENTO"
                               [(ngModel)]="demonstrativoTipoImpressao">
                        Imprimir somente orcamento
                    </label>
                </div>

                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharModalImpressao()">CANCELAR
                    </button>
                    <button type="button" class="cotacao-btn" [disabled]="!temSelecionadosImpressao()"
                            (click)="confirmarImpressaoDemonstrativo('SELECIONADOS')">SELECIONADOS
                    </button>
                    <button type="button" class="cotacao-btn" (click)="confirmarImpressaoDemonstrativo('TODOS')">TODOS
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalCotacoes">
            <div class="cotacao-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Cotacoes Disponiveis
                    <button type="button" class="cotacao-close" (click)="fecharCotacoes()">x</button>
                </div>

                <div class="cotacao-table-scroll">
                    <table class="cotacao-table">
                        <colgroup>
                            <col class="cotacao-col-radio">
                            <col class="cotacao-col-valor">
                            <col class="cotacao-col-data">
                        </colgroup>
                        <thead>
                        <tr>
                            <th></th>
                            <th class="tdLeft">Valor</th>
                            <th class="tdCenter">Data</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let cotacao of cotacoesFiltradas()">
                            <td class="tdRight">
                                <input
                                        type="radio"
                                        name="cotacaoSelecionada"
                                        [checked]="demonstrativoCotacaoSelecionada === cotacao"
                                        (change)="demonstrativoCotacaoSelecionada = cotacao"
                                >
                            </td>
                            <td class="tdLeft">U$ {{ cotacao.valor }}</td>
                            <td class="tdCenter">{{ cotacaoData(cotacao) }}</td>
                        </tr>
                        <tr *ngIf="!cotacoesFiltradas().length">
                            <td class="tdCenter" colspan="3">Nenhuma cotacao encontrada.</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <table class="cotacao-table">
                    <tbody>
                    <tr>
                        <td colspan="3" class="tdLeft">
                            <input
                                    class="cotacao-filtro"
                                    type="text"
                                    placeholder="Buscar Cotacao"
                                    [(ngModel)]="demonstrativoFiltroCotacao"
                            >
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharCotacoes()">
                        CANCELAR
                    </button>
                    <button type="button" class="cotacao-btn" (click)="alterarCotacoes()">
                        SALVAR
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay liberacao-limite-overlay" *ngIf="demonstrativoModalConfirmacaoCotacao">
            <div class="cotacao-modal liberacao-limite-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Confirmar Alteracao de Cotacao
                    <button type="button" class="cotacao-close" (click)="cancelarConfirmacaoCotacao()">x</button>
                </div>

                <div class="cotacao-body liberacao-limite-body">
                    <div class="liberacao-alerta">
                        Confira as vendas que terao a cotacao atualizada antes de confirmar.
                    </div>

                    <div class="liberacao-resumo">
                        <div>
                            <span>Nova cotacao</span>
                            <strong>{{ demonstrativoConfirmacaoCotacao.cotacao }}</strong>
                        </div>
                        <div>
                            <span>Vendas selecionadas</span>
                            <strong>{{ demonstrativoConfirmacaoCotacao.notas.length }}</strong>
                        </div>
                        <div>
                            <span>Atualizacao direta</span>
                            <strong>{{ demonstrativoConfirmacaoCotacao.notas.length }}</strong>
                        </div>
                        <div>
                            <span>Acao</span>
                            <strong>Confirmar envio</strong>
                        </div>
                    </div>

                    <div class="liberacao-table-wrap" *ngIf="demonstrativoConfirmacaoCotacao.notas.length">
                        <table class="cotacao-table ajuste-table">
                            <thead>
                            <tr>
                                <th class="tdCenter">Nota</th>
                                <th class="tdCenter">Titulo</th>
                                <th class="tdCenter">Cotacao atual</th>
                                <th class="tdCenter">Nova cotacao</th>
                                <th class="tdCenter">Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let nota of demonstrativoConfirmacaoCotacao.notas">
                                <td class="tdCenter">{{ nota['codigo'] }}</td>
                                <td class="tdCenter">{{ nota['titulo'] }}</td>
                                <td class="tdCenter">{{ nota['cotacaoAtual'] }}</td>
                                <td class="tdCenter">{{ nota['novaCotacao'] }}</td>
                                <td class="tdCenter">
                        <span [class.liberacao-excede]="nota['acao'] === 'Solicitar liberacao'">
                          {{ nota['acao'] }}
                        </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="cotacao-footer liberacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="cancelarConfirmacaoCotacao()">
                        Cancelar
                    </button>
                    <button type="button" class="cotacao-btn" (click)="confirmarAlteracaoCotacao()">
                        Confirmar
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalPrefixos">
            <div class="cotacao-modal prefixo-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Prefixos Disponiveis
                    <button type="button" class="cotacao-close" (click)="fecharAlterarPrefixo()">x</button>
                </div>

                <div class="cotacao-table-scroll prefixo-table-scroll">
                    <table class="cotacao-table prefixo-table">
                        <colgroup>
                            <col class="prefixo-col-radio">
                            <col class="prefixo-col-prefixo">
                        </colgroup>
                        <thead>
                        <tr>
                            <th></th>
                            <th class="tdLeft">Prefixo</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let prefixo of prefixosAlteracaoFiltrados()">
                            <td class="tdRight">
                                <input
                                        type="radio"
                                        name="prefixoSelecionado"
                                        [checked]="demonstrativoPrefixoSelecionadoAlteracao === prefixo"
                                        (change)="demonstrativoPrefixoSelecionadoAlteracao = prefixo"
                                >
                            </td>
                            <td class="tdLeft">{{ prefixo.prefixo }}</td>
                        </tr>
                        <tr *ngIf="!prefixosAlteracaoFiltrados().length">
                            <td class="tdCenter" colspan="2">Nenhum prefixo encontrado.</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <table class="cotacao-table">
                    <tbody>
                    <tr>
                        <td class="tdLeft">
                            <input
                                    class="cotacao-filtro"
                                    type="text"
                                    placeholder="Buscar Prefixo"
                                    [(ngModel)]="demonstrativoFiltroPrefixoAlteracao"
                            >
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharAlterarPrefixo()">
                        CANCELAR
                    </button>
                    <button type="button" class="cotacao-btn" (click)="atualizarPrefixo()">
                        SALVAR
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay alterar-cliente-overlay" *ngIf="demonstrativoModalAlterarCliente">
            <div class="alterar-cliente-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Alterar cliente das vendas selecionadas
                    <button type="button" class="cotacao-close" (click)="fecharAlterarClienteVendas()">x</button>
                </div>

                <div class="alterar-cliente-body">
                    <div class="alterar-cliente-stepper">
                        <span [class.active]="demonstrativoAlterarClientePasso === 1">1. Novo cliente</span>
                        <span [class.active]="demonstrativoAlterarClientePasso === 2">2. Confirmacao</span>
                        <span [class.active]="demonstrativoAlterarClientePasso === 3">3. Prefixos por venda</span>
                    </div>

                    <ng-container *ngIf="demonstrativoAlterarClientePasso === 1">
                        <div class="alterar-cliente-section alterar-cliente-busca-section alterar-cliente-busca-step">
                            <label class="alterar-cliente-label">Novo cliente</label>
                            <div class="alterar-cliente-busca" (click)="$event.stopPropagation()">
                                <input
                                        class="cotacao-filtro alterar-cliente-busca-input"
                                        type="text"
                                        placeholder="Buscar por nome, documento ou codigo"
                                        [(ngModel)]="demonstrativoAlterarClienteFiltro"
                                        (input)="agendarBuscaClienteAlteracao()"
                                        (keyup.enter)="buscarClientesAlteracao()"
                                        (focus)="demonstrativoAlterarClienteFiltro.trim().length >= 2 && (demonstrativoAlterarClienteDropdownAberto = true)"
                                >

                                <ul class="listaSug alterar-cliente-dropdown alterar-cliente-dropdown-detalhado"
                                    *ngIf="demonstrativoAlterarClienteDropdownAberto">
                                    <li *ngFor="let cliente of demonstrativoAlterarClienteClientes"
                                        (click)="selecionarClienteAlteracao(cliente)">
                                        <strong>{{ cliente.nomeparc }}</strong>
                                        <span>CNPJ: {{ documentoClienteDemonstrativo(cliente) }}</span>
                                    </li>
                                    <li class="listaSug-empty"
                                        *ngIf="!demonstrativoAlterarClienteClientes.length && demonstrativoAlterarClienteStatus">
                                        <span>{{ demonstrativoAlterarClienteStatus }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="alterar-cliente-grid alterar-cliente-selecionado alterar-cliente-enderecos-box"
                             *ngIf="demonstrativoAlterarClienteClienteSelecionado as clienteSelecionado">
                            <div class="alterar-cliente-endereco-card">
                                <span>Novo cliente</span>
                                <strong>{{ labelClienteDemonstrativo(clienteSelecionado) }}</strong>
                                <small>Selecione abaixo o endereco que sera usado na venda.</small>
                            </div>
                            <p class="alterar-cliente-endereco-subtitulo">Selecionar endereco do cliente</p>
                            <div
                                    class="alterar-cliente-enderecos-carregando"
                                    *ngIf="demonstrativoAlterarClienteStatus.startsWith('Buscando')">
                                <app-loading-indicator size="inline"></app-loading-indicator>
                                Carregando Endereços...
                            </div>
                            <section
                                    class="alterar-cliente-enderecos-lista"
                                    *ngIf="!demonstrativoAlterarClienteStatus.startsWith('Buscando')">
                                <button
                                        type="button"
                                        class="alterar-cliente-endereco-opcao"
                                        *ngFor="let endereco of demonstrativoAlterarClienteEnderecos"
                                        [class.selecionado]="demonstrativoAlterarClienteEnderecoSelecionado === endereco"
                                        (click)="selecionarEnderecoAlteracao(endereco)"
                                >
                                    <span>
                                        IE:
                                        {{ formatarInscricaoEstadual(endereco.inscEstadual || '', endereco.uf) || 'Nao informada' }}
                                    </span>
                                    <span>
                                        {{ cidadeUfClienteAlteracaoTexto(endereco) || 'Cidade e UF nao informadas' }}
                                    </span>
                                    <span>
                                        {{ logradouroClienteAlteracaoTexto(endereco) || 'Endereco nao localizado.' }}
                                    </span>
                                </button>
                            </section>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="demonstrativoAlterarClientePasso === 2">
                        <div class="alterar-cliente-section alterar-cliente-atual alterar-cliente-atual-passo-2">
                            <div class="ajuste-nota-resumo">
                                <span>Cliente Atual</span>
                                <span>Prefixo Atual</span>
                                <span>Endereco para entrega atual</span>
                            </div>

                            <div class="alterar-cliente-lista">
                                <div class="alterar-cliente-linha"
                                     *ngFor="let nota of demonstrativoAlterarClienteNotas">
                                    <div>
                                        <strong>{{ nota.nomeparc || '-' }}</strong>
                                        <span>{{ nota.cnpj || '' }}</span>
                                        <small>Venda {{ nunotaFormatadoAlterarCliente(nota) }}</small>
                                    </div>
                                    <div>{{ nota.prefixo || '-' }}</div>
                                    <div>{{ nota.enderecoEntrega || '-' }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="alterar-cliente-grid alterar-cliente-selecionado"
                             *ngIf="demonstrativoAlterarClienteClienteSelecionado as clienteSelecionado">
                            <div>
                                <span>Novo cliente</span>
                                <strong>{{ labelClienteDemonstrativo(clienteSelecionado) }}</strong>
                            </div>
                            <div>
                                <span>Endereco para entrega</span>
                                <strong>{{ enderecoAlterarClienteTexto() || 'Endereco nao localizado.' }}</strong>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="demonstrativoAlterarClientePasso === 3">
                        <div class="alterar-cliente-comparativo">
                            <div class="alterar-cliente-section alterar-cliente-atual alterar-cliente-atual-compacto">
                                <div class="ajuste-nota-resumo">
                                    <span>Cliente Atual</span>
                                    <span>Endereco para entrega atual</span>
                                </div>

                                <div class="alterar-cliente-lista">
                                    <div class="alterar-cliente-linha"
                                         *ngFor="let nota of demonstrativoAlterarClienteNotas">
                                        <div>
                                            <strong>{{ nota.nomeparc || '-' }}</strong>
                                            <span>{{ nota.cnpj || '' }}</span>
                                            <small>Venda {{ nunotaFormatadoAlterarCliente(nota) }}</small>
                                        </div>
                                        <div>{{ nota.enderecoEntrega || '-' }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="alterar-cliente-grid alterar-cliente-selecionado alterar-cliente-novo-compacto"
                                 *ngIf="demonstrativoAlterarClienteClienteSelecionado as clienteSelecionado">
                                <div>
                                    <span>Novo cliente</span>
                                    <strong>{{ labelClienteDemonstrativo(clienteSelecionado) }}</strong>
                                </div>
                                <div>
                                    <span>Endereco para entrega</span>
                                    <strong>{{ enderecoAlterarClienteTexto() || 'Endereco nao localizado.' }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="alterar-cliente-section alterar-cliente-prefixo-vendas-section">
                            <div class="alterar-cliente-prefixo-toolbar">
                                <div>
                                    <label class="alterar-cliente-label">Prefixos por venda</label>
                                    <span>Selecione um prefixo para cada venda, ou aplique o mesmo prefixo para todas.</span>
                                </div>
                                <label>
                                    Aplicar a todos
                                    <select class="alterar-cliente-prefixo-select"
                                            (change)="aplicarPrefixoAlterarClienteTodos($any($event.target).value)">
                                        <option value="">Selecione</option>
                                        <option *ngFor="let prefixo of demonstrativoAlterarClientePrefixos"
                                                [value]="prefixo.codaero">
                                            {{ prefixo.prefixo }}
                                        </option>
                                    </select>
                                </label>
                            </div>

                            <div class="alterar-cliente-prefixo-vendas">
                                <div class="alterar-cliente-prefixo-vendas-header">
                                    <span>Venda</span>
                                    <span>Valor da venda</span>
                                    <span>Prefixo atual</span>
                                    <span>Novo prefixo</span>
                                </div>
                                <div class="alterar-cliente-prefixo-venda-linha"
                                     *ngFor="let nota of demonstrativoAlterarClienteNotas">
                                    <div>
                                        <strong>{{ nunotaFormatadoAlterarCliente(nota) }}</strong>
                                        <span>{{ nota.nomeparc || '-' }}</span>
                                    </div>
                                    <div>{{ valorVendaFormatadoAlterarCliente(nota) }}</div>
                                    <div>{{ nota.prefixo || '-' }}</div>
                                    <select class="alterar-cliente-prefixo-select"
                                            [ngModel]="prefixoSelecionadoAlterarClienteNota(nota)?.codaero || ''"
                                            (ngModelChange)="selecionarPrefixoAlterarClienteNota(nota, $event)">
                                        <option value="">Selecione</option>
                                        <option *ngFor="let prefixo of demonstrativoAlterarClientePrefixos"
                                                [value]="prefixo.codaero">
                                            {{ prefixo.prefixo }}
                                        </option>
                                    </select>
                                </div>
                                <div class="alterar-cliente-prefixo-vazio"
                                     *ngIf="!demonstrativoAlterarClientePrefixos.length">
                                    Nenhum prefixo encontrado para este cliente.
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <div class="cotacao-footer alterar-cliente-footer">
                    <button
                            type="button"
                            class="cotacao-btn cancelar-btn"
                            *ngIf="demonstrativoAlterarClientePasso !== 1"
                            (click)="voltarPassoAlterarCliente()">
                        VOLTAR
                    </button>
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharAlterarClienteVendas()">
                        CANCELAR
                    </button>
                    <button
                            type="button"
                            class="cotacao-btn"
                            *ngIf="demonstrativoAlterarClientePasso === 1"
                            (click)="avancarAlterarCliente()"
                            [disabled]="!demonstrativoAlterarClienteEnderecoSelecionado"
                    >
                        PROXIMO
                    </button>
                    <button
                            type="button"
                            class="cotacao-btn"
                            *ngIf="demonstrativoAlterarClientePasso === 2"
                            (click)="avancarPrefixosAlterarCliente()"
                    >
                        PROXIMO
                    </button>
                    <button
                            type="button"
                            class="cotacao-btn"
                            *ngIf="demonstrativoAlterarClientePasso === 3"
                            (click)="salvarAlterarClienteVendas()"
                            [disabled]="!todasNotasAlterarClienteComPrefixo()"
                    >
                        SALVAR
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay alterar-cliente-overlay" *ngIf="demonstrativoModalAlterarCliente">
            <div class="alterar-cliente-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Alterar cliente das vendas selecionadas
                    <button type="button" class="cotacao-close" (click)="fecharAlterarClienteVendas()">x</button>
                </div>

                <div class="alterar-cliente-body">
                    <div class="alterar-cliente-stepper">
                        <span [class.active]="demonstrativoAlterarClientePasso === 1">1. Novo cliente</span>
                        <span [class.active]="demonstrativoAlterarClientePasso === 2">2. Confirmacao</span>
                        <span [class.active]="demonstrativoAlterarClientePasso === 3">3. Prefixos por venda</span>
                    </div>

                    <ng-container *ngIf="demonstrativoAlterarClientePasso === 1">
                        <div class="alterar-cliente-section alterar-cliente-busca-section alterar-cliente-busca-step">
                            <label class="alterar-cliente-label">Novo cliente</label>
                            <div class="alterar-cliente-busca" (click)="$event.stopPropagation()">
                                <input
                                        class="cotacao-filtro alterar-cliente-busca-input"
                                        type="text"
                                        placeholder="Buscar por nome, documento ou codigo"
                                        [(ngModel)]="demonstrativoAlterarClienteFiltro"
                                        (input)="agendarBuscaClienteAlteracao()"
                                        (keyup.enter)="buscarClientesAlteracao()"
                                        (focus)="demonstrativoAlterarClienteFiltro.trim().length >= 2 && (demonstrativoAlterarClienteDropdownAberto = true)"
                                >

                                <ul class="listaSug alterar-cliente-dropdown alterar-cliente-dropdown-detalhado"
                                    *ngIf="demonstrativoAlterarClienteDropdownAberto">
                                    <li *ngFor="let cliente of demonstrativoAlterarClienteClientes"
                                        (click)="selecionarClienteAlteracao(cliente)">
                                        <strong>{{ cliente.nomeparc }}</strong>
                                        <span>CNPJ: {{ documentoClienteDemonstrativo(cliente) }}</span>
                                    </li>
                                    <li class="listaSug-empty"
                                        *ngIf="!demonstrativoAlterarClienteClientes.length && demonstrativoAlterarClienteStatus">
                                        <span>{{ demonstrativoAlterarClienteStatus }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="alterar-cliente-grid alterar-cliente-selecionado alterar-cliente-enderecos-box"
                             *ngIf="demonstrativoAlterarClienteClienteSelecionado as clienteSelecionado">
                            <div class="alterar-cliente-endereco-card">
                                <span>Novo cliente</span>
                                <strong>{{ labelClienteDemonstrativo(clienteSelecionado) }}</strong>
                                <small>Selecione abaixo o endereco que sera usado na venda.</small>
                            </div>
                            <p class="alterar-cliente-endereco-subtitulo">Selecionar endereco do cliente</p>
                            <div
                                    class="alterar-cliente-enderecos-carregando"
                                    *ngIf="demonstrativoAlterarClienteStatus.startsWith('Buscando')">
                                <app-loading-indicator size="inline"></app-loading-indicator>
                                Carregando Endereços...
                            </div>
                            <section
                                    class="alterar-cliente-enderecos-lista"
                                    *ngIf="!demonstrativoAlterarClienteStatus.startsWith('Buscando')">
                                <button
                                        type="button"
                                        class="alterar-cliente-endereco-opcao"
                                        *ngFor="let endereco of demonstrativoAlterarClienteEnderecos"
                                        [class.selecionado]="demonstrativoAlterarClienteEnderecoSelecionado === endereco"
                                        (click)="selecionarEnderecoAlteracao(endereco)"
                                >
                                    <span>
                                        IE:
                                        {{ formatarInscricaoEstadual(endereco.inscEstadual || '', endereco.uf) || 'Nao informada' }}
                                    </span>
                                    <span>
                                        {{ cidadeUfClienteAlteracaoTexto(endereco) || 'Cidade e UF nao informadas' }}
                                    </span>
                                    <span>
                                        {{ logradouroClienteAlteracaoTexto(endereco) || 'Endereco nao localizado.' }}
                                    </span>
                                </button>
                            </section>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="demonstrativoAlterarClientePasso === 2">
                        <div class="alterar-cliente-section alterar-cliente-atual alterar-cliente-atual-passo-2">
                            <div class="ajuste-nota-resumo">
                                <span>Cliente Atual</span>
                                <span>Prefixo Atual</span>
                                <span>Endereco para entrega atual</span>
                            </div>

                            <div class="alterar-cliente-lista">
                                <div class="alterar-cliente-linha"
                                     *ngFor="let nota of demonstrativoAlterarClienteNotas">
                                    <div>
                                        <strong>{{ nota.nomeparc || '-' }}</strong>
                                        <span>{{ nota.cnpj || '' }}</span>
                                        <small>Venda {{ nunotaFormatadoAlterarCliente(nota) }}</small>
                                    </div>
                                    <div>{{ nota.prefixo || '-' }}</div>
                                    <div>{{ nota.enderecoEntrega || '-' }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="alterar-cliente-grid alterar-cliente-selecionado"
                             *ngIf="demonstrativoAlterarClienteClienteSelecionado as clienteSelecionado">
                            <div>
                                <span>Novo cliente</span>
                                <strong>{{ labelClienteDemonstrativo(clienteSelecionado) }}</strong>
                            </div>
                            <div>
                                <span>Endereco para entrega</span>
                                <strong>{{ enderecoAlterarClienteTexto() || 'Endereco nao localizado.' }}</strong>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="demonstrativoAlterarClientePasso === 3">
                        <div class="alterar-cliente-comparativo">
                            <div class="alterar-cliente-section alterar-cliente-atual alterar-cliente-atual-compacto">
                                <div class="ajuste-nota-resumo">
                                    <span>Cliente Atual</span>
                                    <span>Endereco para entrega atual</span>
                                </div>

                                <div class="alterar-cliente-lista">
                                    <div class="alterar-cliente-linha"
                                         *ngFor="let nota of demonstrativoAlterarClienteNotas">
                                        <div>
                                            <strong>{{ nota.nomeparc || '-' }}</strong>
                                            <span>{{ nota.cnpj || '' }}</span>
                                            <small>Venda {{ nunotaFormatadoAlterarCliente(nota) }}</small>
                                        </div>
                                        <div>{{ nota.enderecoEntrega || '-' }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="alterar-cliente-grid alterar-cliente-selecionado alterar-cliente-novo-compacto"
                                 *ngIf="demonstrativoAlterarClienteClienteSelecionado as clienteSelecionado">
                                <div>
                                    <span>Novo cliente</span>
                                    <strong>{{ labelClienteDemonstrativo(clienteSelecionado) }}</strong>
                                </div>
                                <div>
                                    <span>Endereco para entrega</span>
                                    <strong>{{ enderecoAlterarClienteTexto() || 'Endereco nao localizado.' }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="alterar-cliente-section alterar-cliente-prefixo-vendas-section">
                            <div class="alterar-cliente-prefixo-toolbar">
                                <div>
                                    <label class="alterar-cliente-label">Prefixos por venda</label>
                                    <span>Selecione um prefixo para cada venda, ou aplique o mesmo prefixo para todas.</span>
                                </div>
                                <label>
                                    Aplicar a todos
                                    <select class="alterar-cliente-prefixo-select"
                                            (change)="aplicarPrefixoAlterarClienteTodos($any($event.target).value)">
                                        <option value="">Selecione</option>
                                        <option *ngFor="let prefixo of demonstrativoAlterarClientePrefixos"
                                                [value]="prefixo.codaero">
                                            {{ prefixo.prefixo }}
                                        </option>
                                    </select>
                                </label>
                            </div>

                            <div class="alterar-cliente-prefixo-vendas">
                                <div class="alterar-cliente-prefixo-vendas-header">
                                    <span>Venda</span>
                                    <span>Valor da venda</span>
                                    <span>Prefixo atual</span>
                                    <span>Novo prefixo</span>
                                </div>
                                <div class="alterar-cliente-prefixo-venda-linha"
                                     *ngFor="let nota of demonstrativoAlterarClienteNotas">
                                    <div>
                                        <strong>{{ nunotaFormatadoAlterarCliente(nota) }}</strong>
                                        <span>{{ nota.nomeparc || '-' }}</span>
                                    </div>
                                    <div>{{ valorVendaFormatadoAlterarCliente(nota) }}</div>
                                    <div>{{ nota.prefixo || '-' }}</div>
                                    <select class="alterar-cliente-prefixo-select"
                                            [ngModel]="prefixoSelecionadoAlterarClienteNota(nota)?.codaero || ''"
                                            (ngModelChange)="selecionarPrefixoAlterarClienteNota(nota, $event)">
                                        <option value="">Selecione</option>
                                        <option *ngFor="let prefixo of demonstrativoAlterarClientePrefixos"
                                                [value]="prefixo.codaero">
                                            {{ prefixo.prefixo }}
                                        </option>
                                    </select>
                                </div>
                                <div class="alterar-cliente-prefixo-vazio"
                                     *ngIf="!demonstrativoAlterarClientePrefixos.length">
                                    Nenhum prefixo encontrado para este cliente.
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <div class="cotacao-footer alterar-cliente-footer">
                    <button
                            type="button"
                            class="cotacao-btn cancelar-btn"
                            *ngIf="demonstrativoAlterarClientePasso !== 1"
                            (click)="voltarPassoAlterarCliente()">
                        VOLTAR
                    </button>
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharAlterarClienteVendas()">
                        CANCELAR
                    </button>
                    <button
                            type="button"
                            class="cotacao-btn"
                            *ngIf="demonstrativoAlterarClientePasso === 1"
                            (click)="avancarAlterarCliente()"
                            [disabled]="!demonstrativoAlterarClienteEnderecoSelecionado"
                    >
                        PROXIMO
                    </button>
                    <button
                            type="button"
                            class="cotacao-btn"
                            *ngIf="demonstrativoAlterarClientePasso === 2"
                            (click)="avancarPrefixosAlterarCliente()"
                    >
                        PROXIMO
                    </button>
                    <button
                            type="button"
                            class="cotacao-btn"
                            *ngIf="demonstrativoAlterarClientePasso === 3"
                            (click)="salvarAlterarClienteVendas()"
                            [disabled]="!todasNotasAlterarClienteComPrefixo()"
                    >
                        SALVAR
                    </button>
                </div>
            </div>
        </div>

        <div class="snk-modal-overlay" *ngIf="demonstrativoModalAlerta">
            <div class="snk-modal alerta" (click)="$event.stopPropagation()">
                <div class="snk-modal-header">Advertencia</div>
                <div class="snk-modal-body">
                    {{ demonstrativoModalAlertaTexto }}
                </div>
                <div class="snk-modal-footer">
                    <button type="button" class="snk-btn primary" (click)="fecharModalAlerta()">
                        {{ demonstrativoModalAlertaBotao }}
                    </button>
                </div>
            </div>
        </div>

        <div class="snk-modal-overlay demonstrativo-confirmacao-overlay" *ngIf="demonstrativoModalConfirmacao">
            <div class="snk-modal alerta" (click)="$event.stopPropagation()">
                <div class="snk-modal-header">Confirmacao</div>
                <div class="snk-modal-body">{{ demonstrativoConfirmacao.mensagem }}</div>
                <div class="snk-modal-footer">
                    <button type="button" class="snk-btn primary" (click)="confirmarModal()">
                        {{ demonstrativoConfirmacao.textoOk }}
                    </button>
                    <button type="button" class="snk-btn secondary" (click)="cancelarModal()">
                        {{ demonstrativoConfirmacao.textoCancelar }}
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalFinalizar">
            <div class="cotacao-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Finalizar vendas
                    <button type="button" class="cotacao-close" (click)="fecharModalFinalizar()">x</button>
                </div>
                <div class="cotacao-body">
                    Deseja realmente finalizar as vendas selecionadas?
                </div>
                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharModalFinalizar()">CANCELAR
                    </button>
                    <button type="button" class="cotacao-btn" (click)="confirmarFinalizar()">FINALIZAR</button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalAjusteNotas">
            <div class="cotacao-modal ajuste-modal ajuste-notas-modal"
                 (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Desconto / Acrescimo
                    <button type="button" class="cotacao-close" (click)="fecharAjusteNotas()">x</button>
                </div>

                <div class="ajuste-topo">
                    <label class="ajuste-radio">
                        <input type="radio" name="tipoAjuste" value="DES" [(ngModel)]="demonstrativoAjuste.tipo">
                        Desconto
                    </label>
                    <label class="ajuste-radio">
                        <input type="radio" name="tipoAjuste" value="ACR" [(ngModel)]="demonstrativoAjuste.tipo">
                        Acrescimo
                    </label>
                    <div class="ajuste-campo">
                        <label>Desc/Acres %</label>
                        <input type="text" [(ngModel)]="demonstrativoAjuste.percentual" (blur)="aplicarAjusteTodos()"
                               placeholder="0,00">
                    </div>
                    <div class="ajuste-campo">
                        <label>Desc/Acres $</label>
                        <input type="text" [(ngModel)]="demonstrativoAjuste.valor" (blur)="aplicarAjusteValorGeral()"
                               placeholder="0,00">
                    </div>
                    <button type="button" class="cotacao-btn" (click)="aplicarAjusteTodos()">APLICAR A TODOS</button>
                </div>

                <div class="ajuste-table-wrap">
                    <table class="cotacao-table ajuste-table ajuste-vendas-table">
                        <colgroup>
                            <col class="ajuste-col-acao">
                            <col class="ajuste-col-venda">
                            <col class="ajuste-col-venda">
                            <col class="ajuste-col-valor">
                            <col class="ajuste-col-valor">
                            <col class="ajuste-col-valor">
                            <col class="ajuste-col-imposto">
                            <col class="ajuste-col-imposto">
                            <col class="ajuste-col-total-nota">
                        </colgroup>
                        <thead>
                        <tr>
                            <th></th>
                            <th>Codigo</th>
                            <th>Emissao</th>
                            <th>Total Itens</th>
                            <th>Desc/Acres %</th>
                            <th>Desc/Acres $</th>
                            <th>IPI</th>
                            <th>ST</th>
                            <th>Total Faturado</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of demonstrativoItensAjuste">
                            <td class="tdCenter">
                                <button type="button" class="ajuste-detalhe-btn" title="Editar itens"
                                        aria-label="Editar itens da nota" (click)="abrirAjusteNotaIndividual(item)">✎
                                </button>
                            </td>
                            <td class="tdCenter">{{ item['codigo'] }}</td>
                            <td class="tdCenter">{{ item['emissao'] }}</td>
                            <td class="tdRight ajuste-valor-fixo">{{ item['novoValor'] }}</td>
                            <td class="tdRight">
                                <input class="ajuste-input-table" type="text" [(ngModel)]="item['percentual']"
                                       (blur)="aplicarAjusteItem(item)">
                            </td>
                            <td class="tdRight">
                                <input class="ajuste-input-table" type="text" [(ngModel)]="item['valor']"
                                       (blur)="aplicarAjusteValorItem(item)">
                            </td>
                            <td class="tdRight ajuste-valor-fixo">{{ item['ipi'] }}</td>
                            <td class="tdRight ajuste-valor-fixo">{{ item['st'] }}</td>
                            <td class="tdRight">
                                <input class="ajuste-input-table" type="text" [(ngModel)]="item['totalFaturadoDesejado']"
                                       [disabled]="demonstrativoCalculandoAjusteNativo"
                                       (blur)="aplicarNovoValorItem(item)">
                            </td>
                        </tr>
                        </tbody>
                    <tfoot class="ajuste-total-table">
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="tdRight ajuste-total-valor">{{ demonstrativoAjusteTotalNovoValor }}</td>
                        <td></td>
                        <td class="tdRight ajuste-total-label">Totais</td>
                        <td class="tdRight ajuste-total-valor">{{ demonstrativoAjusteTotalIpi }}</td>
                        <td class="tdRight ajuste-total-valor">{{ demonstrativoAjusteTotalSt }}</td>
                        <td class="tdRight ajuste-total-input-cell">
                            <input class="ajuste-input-table" type="text"
                                   [(ngModel)]="demonstrativoAjusteTotalFaturadoDesejado"
                                   [disabled]="demonstrativoCalculandoAjusteNativo"
                                   (blur)="aplicarNovoValorTotal()">
                        </td>
                    </tr>
                    </tfoot>
                    </table>
                </div>

                <div class="cotacao-footer ajuste-footer-limite">
                    <div class="ajuste-limite-desconto">Limite de desconto: {{ demonstrativoLimiteDescontoVendedor ||
                        '0,00' }}%
                    </div>
                    <button type="button" class="cotacao-btn" (click)="salvarAjusteNotas()">SALVAR</button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay liberacao-limite-overlay" *ngIf="demonstrativoModalLiberacaoLimite">
            <div class="cotacao-modal liberacao-limite-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Solicitar Liberacao de Limite
                    <button type="button" class="cotacao-close" (click)="cancelarLiberacaoLimite()">x</button>
                </div>

                <div class="cotacao-body liberacao-limite-body">
                    <div class="liberacao-alerta">
                        O desconto informado ultrapassa o limite do vendedor. Salve a solicitacao de liberacao para dar
                        continuidade ao fluxo.
                    </div>

                    <div class="liberacao-resumo">
                        <div>
                            <span>Limite do usuario</span>
                            <strong>{{ demonstrativoLiberacaoLimite['limiteUsuario'] || 0 }}%</strong>
                        </div>
                        <div>
                            <span>Maior desconto por nota</span>
                            <strong>{{ demonstrativoLiberacaoLimite['maiorPercentualNota'] || 0 }}%</strong>
                        </div>
                        <div>
                            <span>Desconto geral</span>
                            <strong>{{ demonstrativoLiberacaoLimite['percentualAplicado'] || 0 }}%</strong>
                        </div>
                        <div>
                            <span>Valor de desconto</span>
                            <strong>{{ demonstrativoLiberacaoLimite['valorDescontoTotal'] || 0 }}</strong>
                        </div>
                    </div>

                    <div class="liberacao-table-wrap" *ngIf="demonstrativoLiberacaoLimite['notas']?.length">
                        <table class="cotacao-table ajuste-table">
                            <thead>
                            <tr>
                                <th class="tdCenter">Nota</th>
                                <th class="tdCenter">Total bruto</th>
                                <th class="tdCenter">Desconto</th>
                                <th class="tdCenter">% aplicado</th>
                                <th class="tdCenter">Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let nota of demonstrativoLiberacaoLimite['notas']">
                                <td class="tdCenter">{{ nota['nunota'] }}</td>
                                <td class="tdCenter">{{ nota['totalBruto'] }}</td>
                                <td class="tdCenter">{{ nota['valorDesconto'] }}</td>
                                <td class="tdCenter">{{ nota['percentualDesconto'] }}%</td>
                                <td class="tdCenter">
                        <span [class.liberacao-excede]="nota['excedeLimite']">
                          {{ nota['excedeLimite'] ? 'Excede limite' : 'Dentro do limite' }}
                        </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="liberacao-retorno" *ngIf="demonstrativoLiberacaoLimite['mensagemSolicitacao']">
                        {{ demonstrativoLiberacaoLimite['mensagemSolicitacao'] }}
                    </div>
                </div>

                <div class="cotacao-footer liberacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="cancelarLiberacaoLimite()">
                        Cancelar
                    </button>
                    <button type="button" class="cotacao-btn" (click)="salvarSolicitacaoLiberacaoLimite()">
                        Salvar solicitacao
                    </button>
                    <button type="button" class="cotacao-btn liberacao-btn" (click)="liberarLimiteDesconto()">
                        LIBERAR
                    </button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalAjusteNotaIndividual && demonstrativoNotaAjuste">
            <div class="cotacao-modal ajuste-modal ajuste-nota-individual-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Ajuste de Nota
                    <button type="button" class="cotacao-close" (click)="fecharAjusteNotaIndividual()">x</button>
                </div>

                <div class="ajuste-nota-resumo">
                    <span>Codigo: {{ demonstrativoNotaAjuste['codigo'] }}</span>
                    <span>Valor: {{ demonstrativoNotaAjuste['novoValor'] }}</span>
                </div>

                <div class="ajuste-table-wrap">
                    <table class="cotacao-table ajuste-table ajuste-itens-table">
                        <colgroup>
                            <col class="ajuste-col-pn">
                            <col class="ajuste-col-produto">
                            <col class="ajuste-col-qtd">
                            <col class="ajuste-col-item-valor">
                            <col class="ajuste-col-item-valor">
                            <col class="ajuste-col-item-valor">
                            <col class="ajuste-col-item-valor">
                            <col class="ajuste-col-item-valor">
                        </colgroup>
                        <thead>
                        <tr>
                            <th class="tdLeft">P/N</th>
                            <th class="tdLeft">Produto</th>
                            <th>Qtd.</th>
                            <th>Vlr. Unit.</th>
                            <th>Vlr. Total</th>
                            <th>Desc/Acres %</th>
                            <th>Desc/Acres $</th>
                            <th>Novo Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of demonstrativoItensNotaAjuste">
                            <td class="tdLeft">{{ item['partnumber'] }}</td>
                            <td class="tdLeft">{{ item['produto'] }}</td>
                            <td class="tdRight">{{ item['qtd'] }}</td>
                            <td class="tdRight">{{ item['vlrUnit'] }}</td>
                            <td class="tdRight">{{ item['vlrTotal'] }}</td>
                            <td class="tdRight">
                                <input class="ajuste-input-table" type="text" [(ngModel)]="item['percentual']"
                                       [disabled]="demonstrativoCalculandoAjusteNativo"
                                       (blur)="aplicarAjusteItemNotaPercentual(item)">
                            </td>
                            <td class="tdRight">
                                <input class="ajuste-input-table" type="text" [(ngModel)]="item['valor']"
                                       [disabled]="demonstrativoCalculandoAjusteNativo"
                                       (blur)="aplicarAjusteItemNotaValor(item)">
                            </td>
                            <td class="tdRight">
                                <input class="ajuste-input-table" type="text" [(ngModel)]="item['novoValor']"
                                       [disabled]="demonstrativoCalculandoAjusteNativo"
                                       (blur)="aplicarNovoValorItemNota(item)">
                            </td>
                        </tr>
                        </tbody>
                        <tfoot class="ajuste-total-table">
                        <tr>
                            <td></td>
                            <td class="tdRight ajuste-total-label">Totais</td>
                            <td></td>
                            <td></td>
                            <td class="tdRight ajuste-total-valor ajuste-total-original">{{ demonstrativoTotalNotaOriginal }}</td>
                            <td></td>
                            <td></td>
                            <td class="tdRight ajuste-total-valor ajuste-total-novo">{{ demonstrativoTotalNotaNovoValor }}</td>
                        </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="cotacao-footer ajuste-footer-limite">
                    <div class="ajuste-limite-desconto">Limite de desconto: {{ demonstrativoLimiteDescontoVendedor ||
                        '0,00' }}%
                    </div>
                    <div class="ajuste-footer-acoes">
                        <button type="button" class="cotacao-btn" (click)="salvarAjusteNotaIndividual()">SALVAR</button>
                        <button type="button" class="cotacao-btn cancelar-btn" (click)="voltarParaAjusteNotas()">
                            VOLTAR
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalTipoNegociacaoResumo">
            <div class="cotacao-modal ajuste-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Alterar Forma de Pagamento
                    <button type="button" class="cotacao-close" (click)="fecharModalTipoNegociacaoResumo()">x</button>
                </div>

                <div class="ajuste-nota-resumo">
                    <span>Vendas a serem afetadas</span>
                </div>

                <div class="ajuste-table-wrap">
                    <table class="cotacao-table ajuste-table">
                        <thead>
                        <tr>
                            <th>Codigo</th>
                            <th>Num titulo</th>
                            <th>Emissao</th>
                            <th>Status</th>
                            <th>Vlr final</th>
                            <th>Tipo de negociacao atual</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let venda of demonstrativoVendasTipoNegociacao">
                            <td class="tdCenter">{{ venda['codigo'] }}</td>
                            <td class="tdCenter">{{ venda['numTitulo'] }}</td>
                            <td class="tdCenter">{{ venda['emissao'] }}</td>
                            <td class="tdCenter">{{ venda['status'] }}</td>
                            <td class="tdCenter">{{ venda['valorFinal'] }}</td>
                            <td class="tdCenter">{{ venda['tipoNegociacaoAtual'] }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharModalTipoNegociacaoResumo()">
                        CANCELAR
                    </button>
                    <button type="button" class="cotacao-btn" (click)="proximoTipoNegociacao()">PROXIMO</button>
                </div>
            </div>
        </div>

        <div class="cotacao-overlay" *ngIf="demonstrativoModalTipoNegociacao">
            <div class="cotacao-modal ajuste-modal tipo-negociacao-modal" (click)="$event.stopPropagation()">
                <div class="cotacao-header">
                    Selecionar Forma de Pagamento
                    <button type="button" class="cotacao-close" (click)="fecharModalTipoNegociacao()">x</button>
                </div>

                <div class="ajuste-topo">
                    <div class="ajuste-campo ajuste-campo-largo">
                        <label>Buscar forma de pagamento</label>

                        <input
                                type="text"
                                [(ngModel)]="demonstrativoFiltroTipoVenda"
                                placeholder="Descricao"
                        >
                    </div>
                </div>

                <div class="ajuste-table-wrap tipo-negociacao-table-wrap">
                    <table class="cotacao-table ajuste-table">
                        <colgroup>
                            <col style="width: 52px;">
                            <col>
                        </colgroup>

                        <thead>
                        <tr>
                            <th></th>
                            <th class="tdLeft">Forma de pagamento</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr
                                *ngFor="let tipo of tiposVendaFiltrados()"
                                (click)="demonstrativoTipoVendaSelecionado = tipo"
                                style="cursor: pointer;"
                        >
                            <td class="tdCenter">
                                <input
                                        type="radio"
                                        name="tipoVendaSelecionado"
                                        [checked]="demonstrativoTipoVendaSelecionado === tipo"
                                        (change)="demonstrativoTipoVendaSelecionado = tipo"
                                        (click)="$event.stopPropagation()"
                                >
                            </td>

                            <td class="tdLeft">
                                {{ tipo['descricao'] }}
                            </td>
                        </tr>

                        <tr *ngIf="!tiposVendaFiltrados().length">
                            <td colspan="2" class="tdCenter">
                                Nenhuma forma de pagamento encontrada.
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="cotacao-footer">
                    <button type="button" class="cotacao-btn cancelar-btn" (click)="fecharModalTipoNegociacao()">
                        CANCELAR
                    </button>
                    <button type="button" class="cotacao-btn" (click)="alterarTipoNegociacao()">ALTERAR</button>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</div>
